import * as Services from "../models/swagger/generated-records-service";

export const RecordsService = {
    caseSearch: Services.CasesService.search,
    getMyCases: Services.CasesService.myCases,
    getCaseByUcn: Services.CasesService.caseByUcn,
    longCaseSearch: Services.CasesService.longcasesearch,
    poll: Services.CasesService.caseSearchpoll,
};

export const JobsService = {
    execute: Services.CaseExportService.caseExport,
    get: Services.CaseExportService.caseExport1,
};

export const TylerRecordService = {
    /// search for cases by using a case search object
    /// when logged in as a Tyler user.
    ///
    /// @param {Object} params - insert a `CaseSearch` Object
    /// post request to the server.
    longCaseSearch: Services.CasesService.longcasesearch1,
    /// search for cases by using a case search Object
    /// when logged in as a Tyler user.
    ///
    /// @remarks This uses the Common Library directly.
    /// @param {Object} params - insert a `CaseSearch` Object
    /// post request to the server.
    localCaseSearch: Services.CasesService.search1,
    /// search for cases by using a countyId, a divishionId, and a case number.
    ///
    /// @param {Object} params - get cases by ucn, countyId, and divisionId.
    /// @param {string} params.ucn - the ucn of the case.
    /// @param {string} params.countyId - the countyId of the case.
    /// @param {string} params.divisionId - the divisionId of the case.
    getCaseByUcn: Services.CasesService.getcasebyucn,
    poll: Services.CasesService.poll1,
};
